/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

// THIS FILE WAS AUTOGENERATED
/**
 * Defines the level of severity for the event.
 */
export var SeverityLevel;
(function (SeverityLevel) {
  SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
  SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
  SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
  SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
  SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));